import { render, staticRenderFns } from "./ContentFooter2.vue?vue&type=template&id=654ee3e0&scoped=true&"
import script from "./ContentFooter2.vue?vue&type=script&lang=js&"
export * from "./ContentFooter2.vue?vue&type=script&lang=js&"
import style0 from "./ContentFooter2.vue?vue&type=style&index=0&id=654ee3e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654ee3e0",
  null
  
)

export default component.exports